'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');

var clearSelection = function (element) {
    const dropdownElement = $(element).closest('.dropdown.show');
    dropdownElement.children('.nav-link').attr('aria-expanded', 'false');
    dropdownElement.children('.dropdown-menu').attr('aria-hidden', 'true');
    dropdownElement.removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
};

var keyboardAccessibilityTabEscape = function () {
    $('.navbar-header .user .popover').removeClass('show');
    $('.user').attr('aria-expanded', 'false');
};

module.exports = function () {
    var isDesktop = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('d-none');
        window.sessionStorage.setItem('hide_header_banner', '1');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $('.header-banner').removeClass('d-none');
    }

    keyboardAccessibility(
        '.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) {
                // down
                if (menuItem.hasClass('nav-item')) {
                    // top level
                    $('.navbar-nav .show').removeClass('show').children('.dropdown-menu').removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    menuItem.find('ul > li > a').first().focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    if (!(menuItem.next().length > 0)) {
                        // if this is the last menuItem
                        menuItem
                            .parent()
                            .parent()
                            .find('li > a')
                            // set focus to the first menuitem
                            .first()
                            .focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            39: function (menuItem) {
                // right
                if (menuItem.hasClass('nav-item')) {
                    // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a').first().focus();
                }
            },
            38: function (menuItem) {
                // up
                if (menuItem.hasClass('nav-item')) {
                    // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                } else if (menuItem.prev().length === 0) {
                    // first menuItem
                    menuItem.parent().parent().removeClass('show').children('.nav-link').attr('aria-expanded', 'false');
                    menuItem
                        .parent()
                        .children()
                        .last()
                        .children()
                        // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) {
                // left
                if (menuItem.hasClass('nav-item')) {
                    // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show').closest('li.show').removeClass('show').children().first().focus().attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) {
                // escape
                var parentMenu = menuItem.hasClass('show') ? menuItem : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link').attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            },
        },
        function () {
            return $(this).parent();
        }
    );

    $('.dropdown:not(.disabled) [data-toggle="dropdown"]:not(".no-flyout")')
        .on('click', function (e) {
            if (!isDesktop(this)) {
                const $this = $(this);
                $('.modal-background').show();
                // copy parent element into current UL
                var li = $('<li class="dropdown-item top-category" role="button"></li>');
                var link = $this.clone().removeClass('dropdown-toggle').removeAttr('data-toggle').removeAttr('aria-expanded').attr('aria-haspopup', 'false');
                li.append(link);
                var closeMenu = $('<li class="nav-menu"></li>');
                closeMenu.append($('.close-menu').first().clone());
                $this.parent().children('.dropdown-menu').prepend(li).prepend(closeMenu).attr('aria-hidden', 'false');
                // copy navigation menu into view
                $this.parent().addClass('show');
                $this.attr('aria-expanded', 'true');
                $(link).focus();
                $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
                e.preventDefault();
            }
        })
        .on('mouseenter', function () {
            if (isDesktop(this)) {
                var eventElement = this;
                $('.navbar-nav > li').each(function () {
                    if (!$.contains(this, eventElement)) {
                        const $this = $(this);
                        $this.find('.show').each(function () {
                            clearSelection(this);
                        });
                        if ($this.hasClass('show')) {
                            $this.removeClass('show');
                            $this.children('ul.dropdown-menu').removeClass('show');
                            $this.children('.nav-link').attr('aria-expanded', 'false');
                        }
                    }
                });
                // need to close all the dropdowns that are not direct parent of current dropdown
                $(this).parent().addClass('show');
                $(this).siblings('.dropdown-menu').addClass('show');
                $(this).attr('aria-expanded', 'true');
            }
        })
        .parent()
        .on('mouseleave', function () {
            if (isDesktop(this)) {
                const $this = $(this);
                $this.removeClass('show');
                $this.children('.dropdown-menu').removeClass('show');
                $this.children('.nav-link').attr('aria-expanded', 'false');
            }
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        const mainMenu = $('.main-menu');
        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();

        $('.navbar-toggler').focus();

        mainMenu.attr('aria-hidden', 'true');
        mainMenu.siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        const $this = $(this);
        $this.closest('.dropdown').children('.dropdown-menu').children('.top-category').detach();
        clearSelection(this);
        $this.closest('li').detach();
    });

    $('.navbar-header').on('click', '.close-button', function (e) {
        e.preventDefault();
        const $this = $(this);
        const navBar = $('.navbar-nav');
        $this.toggleClass('d-none');
        $this.closest('.navbar-header').find('.navbar-toggler').toggleClass('d-none');
        navBar.find('.top-category').detach();
        navBar.find('.nav-menu').detach();
        navBar.find('.show').removeClass('show');
        $('.menu-toggleable-left').removeClass('in');

        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');

        $('.modal-background').hide();
    });

    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        const $this = $(this);
        const mainMenu = $('.main-menu');
        $this.closest('.navbar-header').find('.close-button').toggleClass('d-none');
        $this.closest('.navbar-header').find('.navbar-toggler').toggleClass('d-none');
        mainMenu.toggleClass('in');
        $('.modal-background').show();
        $('body').toggleClass('no-scroll');

        mainMenu.removeClass('d-none');
        mainMenu.attr('aria-hidden', 'false');
        mainMenu.siblings().attr('aria-hidden', 'true');
        $('header').siblings().attr('aria-hidden', 'true');

        $('.main-menu .nav.navbar-nav .nav-link').first().focus();
    });

    $('div.navbar-header>.close-button').on('click', function (e) {
        e.preventDefault();
        const $mainMenu = $('.main-menu');

        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();
        $('body').removeClass('no-scroll');
        $('nav').removeClass('menu-active');
        $('.navbar-toggler').focus();
        $mainMenu.attr('aria-hidden', 'true');
        $mainMenu.siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
    });

    keyboardAccessibility(
        '.navbar-header .user',
        {
            40: function ($popover) {
                // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) {
                // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function () {
                // escape
                keyboardAccessibilityTabEscape();
            },
            9: function () {
                // tab
                keyboardAccessibilityTabEscape();
            },
        },
        function () {
            var $popover = $('.user .popover li.nav-item');
            return $popover;
        }
    );

    const popover = $('.navbar-header .user .popover');
    $('.navbar-header .user').on('mouseenter focusin', function () {
        if (popover.length > 0) {
            popover.addClass('show');
            $('.user').attr('aria-expanded', 'true');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        popover.removeClass('show');
        $('.user').attr('aria-expanded', 'false');
    });

    const $body = $('body');
    const viewAllText = $('.navbar').data('viewall-text');

    $body.on('click', '#myaccount', function (event) {
        event.preventDefault();
    });

    // custom Montblanc Code
    $body.on('mouseenter', '.nav-link', function () {
        if (isDesktop(this)) {
            const $this = $(this);
            const $parent = $this.parent();
            const $subcategory = $this.parent('.nav-item').find('.megaflyout > .dropdown-list > .nav-item');
            if ($subcategory.find('> .multi').length === 1 || $subcategory.find('> .single').length === 1) {
                const $navFirstChild = $parent.find('.megaflyout .dropdown-list .nav-item .multi > .nav-item:first-child');
                $navFirstChild.addClass('show');
                $navFirstChild.find('.inline-menu').addClass('show');
                if ($navFirstChild.find('.inline-menu .view-all').length === 0) {
                    $navFirstChild
                        .find('.inline-menu')
                        .append('<li class="inline-menu-item view-all-link"><a class="view-all" href="' + $this.data('href') + '">' + viewAllText + '</a></li>');
                }
            } else {
                const $navFirstChild = $parent.find('.megaflyout .dropdown-list .nav-item:first-child');
                $navFirstChild.addClass('show');
                $navFirstChild.find('.inline-menu').addClass('show');
                if ($navFirstChild.find('.inline-menu .view-all').length === 0) {
                    $navFirstChild
                        .find('.inline-menu')
                        .append('<li class="inline-menu-item view-all-link"><a class="view-all" href="' + $this.data('href') + '">' + viewAllText + '</a></li>');
                }
            }
        }
    });

    $body.on('mouseenter', '.dropdown-link', function () {
        if (isDesktop(this)) {
            const $this = $(this);
            const $parent = $this.parent();
            if ($this.parent('li:not(:first-child)').length !== 0) {
                $parent.parent().find('.nav-item:first-child').removeClass('show');
                $parent.parent().find('.nav-item:first-child .inline-menu').removeClass('show');
            } else {
                $parent.find('.nav-item:first-child').addClass('show');
                $parent.addClass('show');
            }
            $parent.find('.inline-menu .inline-menu-item.view-all-link').remove();
            $parent.find('.inline-menu').append('<li class="inline-menu-item view-all-link"><a class="view-all" href="' + $this.data('href') + '">View all</a></li>');
        }
    });

    $body.on('click', '#myaccount', function () {
        var accountShowLink = $(this).attr('href');
        window.location.href = accountShowLink;
    });
};
